module.exports = __webpack_public_path__ + "static/img/10.b807750.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/10.png
// module id = avD5
// module chunks = 0